import "./PrivacyPolicy.css";
import { NavLink } from "react-router-dom";
export const PrivacyPolicy = () => {
  return (
    <div id="privacy-policy" className="yellow-bg container policy-width hurme-3-regular letter-spacing">
      <h1 className="align-center">NAYAX Capital</h1>
      <p className="align-center">
        <strong>Privacy Policy</strong>
      </p>
      <p className="align-center">[Last Updated: February 1st, 2024] </p>
      <p>
        <br></br>
      </p>
      <p>
        Welcome to NAYAX Capital operated by by IoT Capital Technology Holdings Ltd., a NAYAX affiliate and business partner (“NAYAX Capital”,
        “Company”, or “us”). NAYAX Capital is committed to your right to
        privacy. This Privacy Policy (the “Privacy Policy”) is an integral part
        of our Terms and Conditions, applicable in each jurisdiction and governs
        the processing and transfer of data collected in connection with our
        services, including the Capital Solutions (as such terms is defined in
        the Terms and Conditions applicable in each jurisdiction) ("Services") offered by us to Nayax Customers
        (the “User” or “you”) using the Services.
      </p>
      <p>
        <br></br>
      </p>
      <p>
        NAYAX Capital is part of the Nayax group that includes Nayax Ltd. and
        affiliated companies (“NAYAX Group”). In addition to this Privacy Policy
        and the applicable <NavLink className="nav-link" to="/terms-conditions" target="_blank">Terms and Conditions</NavLink>, other terms may apply to you,
        with respect to the services you subscribed to, as indicated in the
        applicable agreement executed between you and the relevant Nayax group
        entity and as specified in{" "}
        <a href="https://www.nayax.com/legal/nayax-general-privacy-policy/" className="nav-link" target="_blank">
          Nayax's General Privacy Policy.
        </a>
      </p>
      <p>
        <br></br>
      </p>
      <p>
        This Privacy Policy explains what information we may collect, how such
        information may be used or shared with others, how we safeguard it and
        how Users may exercise their rights related to their Personal
        Information (as such term is defined below), among others, according to
        the California Consumer Privacy Act (“CCPA”), where applicable. If you
        choose to use, interact with, register or provide data to us or through
        the Services you explicitly agree to the use of such data in accordance
        with this Privacy Policy. You may not use the Services or submit any
        data through the Services if you do not agree to any of the provisions
        hereunder. This Privacy Policy shall not be construed in any manner to
        derogate from the Terms and Conditions applicable in each jusridiction, or any other agreement made by
        and between NAYAX Capital or NAYAX and you. Any terms used herein and
        not defined shall have the meaning ascribed to them in the applicable{" "}
        <NavLink className="nav-link" to="/terms-conditions" target="_blank">Terms and Conditions.</NavLink>
      </p>
      <br />
      <p>
        <strong>THE HIGHLIGHTS:</strong>
      </p>
      <ul>
        <li>
          You are not required by law to provide us with any Personal
          Information. Sharing Personal Information with us is entirely
          voluntary although we do receive certain Personal Information about you from Nayax.{" "}
        </li>
        <li>
          Our Services are intended for Users over the age of 18. If you are
          under such age you should cease to use the Services immediately.{" "}
        </li>
        <li>
          You may be entitled to request to review, access, amend, erase or
          restrict the processing of your Personal Information, pursuant to
          applicable law. Please note that in case you request to erase or
          restrict the processing of your Personal Information, your use of the
          Services may be restricted.{" "}
        </li>
        <li>
          We do not sell, trade, or rent Users’ Personal Information to third
          parties. We only share Personal Information with third parties in
          connection with the provision of the Services to our Users, or other
          limited circumstances specified herein.{" "}
        </li>
        <li>
          If you have any questions or requests regarding the processing of your
          Personal Information, or would otherwise like to contact us in
          connection with this Privacy Policy, please send us an email to:
          <a href="mailto:privacy@nayax.com">privacy@nayax.com</a>.
        </li>
      </ul>
      <br></br>
      <ol>
        <li>
          <strong>
            What is Personal Information and what data is collected about me by
            NAYAX CAPITAL ?
          </strong>
          <p>
            <b>“Personal Information”</b>, means any information which identifies or
            can be used to identify a natural person, including, but not limited
            to, first and last name, phone number, email address, online
            identifiers, IP address, billing information (such as credit card
            number), information concerning households, devices etc. Under the
            CCPA, “personal information” is any information that identifies,
            relates to, describes, is reasonably capable of being associated
            with, or could reasonably be linked, directly or indirectly, with a
            particular California resident or household. It does not include
            publicly available data as defined by the CCPA. 
            <br /> 
            <b>“Non-Personal
            Information”</b>, As opposed to Personal Data, non-personal data, or
            anonymized data, is information which does not identify a specific
            natural person and cannot reasonably be used for such
            identification. This type of information includes for example
            aggregate or statistical data, technical information transmitted
            from your device such as type of browser and operating system,
            language preference, referring and exit pages and URLs, time and
            date stamp, and amount of time spent on particular page.
            <br />
            <br />
            Personal Information is only used for limited purposes, as specified
            below.{" "}
          </p>
          <div className="policy-grid">
            <div className="policy-grid-item">
              <strong>Type of user and type of Data</strong>
            </div>
            <div className="policy-grid-item">
              <strong>Purposes of Processing </strong>
            </div>
            <div className="policy-grid-item">
              <strong>Lawful Basis</strong>
            </div>
            <div className="policy-grid-item">
              <strong>Registration of new Users to the Services</strong>
              <p>
                In order to use the Services, you will be asked to create an
                account and provide us with Personal Information, such as your
                name, email address, phone number and business information
                related to your NAYAX devices, such as number of units, products
                offered by you, etc. This information is provided by you when
                registering the Services and creating an account to use the
                Services.
              </p>
            </div>
            <div className="policy-grid-item">
              <ul>
                <li>
                  To onboard a User to our Services and sign-up registration and
                  provide with a bespoke funding offer;
                </li>
                <li>
                  To resolve any disputes, communicate with you regarding
                  customer service and support issues, and to respond to
                  questions or comments and help resolve any problems.
                </li>
                <li>
                  To provide updates with respect to material changes to this
                  Privacy Policy or our Terms and Conditions, applicable in each jurisdiction.
                </li>
                <li>
                  To improve the Services, and to develop new features, products and services.
                </li>
              </ul>
            </div>
            <div className="policy-grid-item">
              <p>
                In order to take steps at the request of the User prior to
                entering into a contract.{" "}
              </p>
            </div>
            <div className="policy-grid-item">
              <strong>
                Receive a funding offer from NAYAX Capital
              </strong>
              <p>
                In order to utilize the bespoke funding offer, provided to you by us when you purchase at NAYAX's eComm website, we will receive
                from NAYAX (unless you express your objection to NAYAX beforehand), the following data about you and
                your business: information about transactions associated with
                your machines (machine IP & latitude), billing reports,
                machines, devices, geo location (country, state, zip-code), as
                well as your name, address, contract and your outstanding
                balance. Note, most of the data above is associated with
                businesses (b2b), in certain cases it will be associated to sole
                traders/individuals. In both cases, we treat the Personal
                Information in accordance with this Privacy Policy. This
                information is provided by NAYAX. Please note, in certain
                cases we will be required to conduct a risk evaluation in order
                to determine the funding terms. For such purpose, and subject to
                your explicit approval, we will require visibility to your bank
                statements, existing loans and debts, and credit score. This
                done through access to your personal and business credit bureau
                assessment.
              </p>
            </div>
            <div className="policy-grid-item">
              <p>
                To provide the Services, and offer you with a customized funding
                offer.
              </p>
            </div>
            <div className="policy-grid-item">
              <ol>
              <li>
                  NAYAX CAPITAL receives the Personal Information from NAYAX based on the legitimate interests of NAYAX CAPITAL in developing its business and expanding its offerings to customers. This is also the legal basis of NAYAX CAPITAL’s use of this information to call you with a funding offer.
                </li>
                <li>
                  If you are in the European Economic Area other than the UK or France, the legal basis of NAYAX CAPITAL’s use of your information to send you marketing emails and SMS about the funding offers is your consent, which you can provide as explained below.
                </li>
                <li>
                  If you are in the UK or France, the legal basis of NAYAX CAPITAL’s use of your information to send you marketing emails and SMS about the funding offers is the legitimate interests of NAYAX CAPITAL in developing its business and expanding its offerings to customers.
                </li>
                <li>To fulfil our legal obligation.</li>
              </ol>
            </div>
            <div className="policy-grid-item">
              <strong>Performance of the Services</strong>
              <p>
                Once we provided you with a funding, we will keep processing the
                information above, as well as, any information associated with
                your remaining payments, debts, purchased devices, etc.
              </p>
            </div>
            <div className="policy-grid-item">
              <p>
                To provide the Services, and offer you with a customized funding
                offer. To improve the Services, and to develop new features,
                products and services.
              </p>
            </div>
            <div className="policy-grid-item">
              <ol>
              <li>
                  Necessity of processing for the purposes of the legitimate
                  interests of NAYAX CAPITAL.
                </li>
                <li>To perform the contract which the User is a party.</li>
                <li>
                  In order to take steps at the request of the User prior to
                  entering into a contract.
                </li>
                <li>To fulfil our legal obligation.</li>
              </ol>
            </div>
            <div className="policy-grid-item">
              <strong>   Technical Information and Online Identifiers</strong>
              <p>
                We collect technical information transmitted by your device when
                using the Services. Such information includes type of operating
                system, type of the device used to access the Services, date and
                time stamp, language preference, device ID, IP address,
                advertising ID (android), IDFA (apple advertising ID) and user’s
                actions within the Services. 
                <strong>
                  This information is collected automatically via your use of
                  the Services.
                </strong>
              </p>
            </div>
            <div className="policy-grid-item">
              <ul>
                <li>To identify authorized users of Customer.</li>
                <li>To access and use the Services.</li>
                <li>
                  To resolve any disputes, communicate with you regarding
                  customer service and support issues, and to respond to
                  questions or comments and help resolve any problems.
                </li>
                <li>
                  To improve the Services, and to develop new features, products
                  and services.
                </li>
              </ul>
            </div>
            <div className="policy-grid-item">
              <ol>
                <li>
                  Necessity of processing for the purposes of the legitimate
                  interests of NAYAX CAPITAL.
                </li>
                <li>To perform the contract which the User is a party.</li>
              </ol>
            </div>
            <div className="policy-grid-item">
              <strong>Contact us</strong>
              <p>
                When you submit a customer-service request or using the <b>“contact us”</b> feature, you may be asked to provide personal information
                depending on the activity or request. For example, by placing a
                message in the <b>“contact us”</b> form we will collect your full name,
                email, mobile number, country, company, and the content of your
                message.{" "}
              </p>
            </div>
            <div className="policy-grid-item">
              <ul>
                <li>
                  To answer your queries and provide you with the services you
                  requested from us.{" "}
                </li>
                <li>
                  To improve the Services, and to develop new features, products
                  and services.
                </li>
              </ul>
            </div>
            <div className="policy-grid-item">
              <ol>
                <li>
                  Necessity of processing for the purposes of the legitimate
                  interests of NAYAX CAPITAL.
                </li>
                <li>To perform the contract which the User is a party.</li>
                <li>To fulfil our legal obligation.</li>
              </ol>
            </div>
          </div>
          <p>
            In addition, we may use certain Personal Information to prevent
            potentially prohibited or illegal activities, fraud,
            misappropriation, infringements, identity thefts and any other
            misuse of the website or the Services and to enforce the Terms and
            Conditions, as well as to protect the security or integrity of our
            databases, website and the Services, and to take precautions against
            legal liability. Additionally, we may also use Personal Information
            to comply with any applicable law and assist law enforcement
            agencies and competent authorities, when we have a good faith belief
            that our cooperation with them meets the applicable legal standards.
            All the above processing is based on out legitimate interests or
            legal requirements. Non-Personal Information, aggregate and
            statistical or otherwise anonymized data may be shared without
            limitation with third parties at our discretion. This information
            does not contain Personal Information and is used to develop content
            and services for our Users.{" "}
          </p>
        </li>
        <li>
          <strong>Will NAYAX CAPITAL Share my Personal Information? </strong>
          <p>
            We share Personal Information only under the following limited
            circumstances:{" "}
          </p>
          <ul>
            <li>
              With third parties who assist us in operating the Services –
              conducting our business, expanding our business or servicing you,
              and for personalizing your experience of the Services, such as
              cloud hosting services, risk analysis services, etc. These also include distributers and resellers.{" "}
            </li>
            <li>
              Within the Nayax group – We also share certain Personal
              Information within the Nayax group, where certain affiliated
              companies provide services to assist others entities in the group
              in the provision of our services. For example, Nayax Ltd.
              headquarters the group's activities, and may have access to
              Personal Information collected by its subsidiaries.{" "}
            </li>
            <li>
              In the event of a corporate transaction – (e.g., sale of a
              substantial part of our business, merger, consolidation or asset
              sale). In such case, our affiliated companies or acquiring company
              will assume the rights and obligations as described in this
              Privacy Policy{" "}
            </li>
            <li>
              For legal purposes – To comply with a legal requirement, for the
              administration of justice, to protect your vital interests or the
              vital interests of others, to protect the security or integrity of
              our databases or the Services, to take precautions against legal
              liability, or in the event of a corporate sale, merger,
              reorganization, dissolution or similar event.{" "}
            </li>
          </ul>
        </li>
        <li>
          <strong>
            Will NAYAX CAPITAL transfer my Personal Information internationally?{" "}
          </strong>
          <p>
            NAYAX CAPITAL is a global company with offices all over the world.
            Our databases are located currently in US, EU and Australia.
            Some of our processing activities are made in Israel. International
            transfers of data are done with appropriate measures to ensure that
            your Personal Information receives an adequate level of protection
            as required under applicable law.{" "}
          </p>
          <br />
          <strong>Users' rights with respect to Personal Information </strong>
          <p>
            Depending on your jurisdiction, data protection and privacy laws
            provide you with the ability to exercise certain rights regarding
            your Personal Information that we process. Please note that, unless
            you instruct us otherwise, we retain the information we collect for
            as long as needed to provide the Services and to comply with our
            legal obligations, resolve disputes and enforce our agreements. If
            you object to the aforesaid collection, use and sharing of data,
            please immediately cease using the Services.{" "}
          </p>
          <br />
          <p>
            Data subject rights include (depending on your jurisdiction and
            applicable law):{" "}
          </p>
          <ul>
            <li>
              the right to receive confirmation whether or not we process your
              Personal Data;
            </li>
            <li>
              the right to access your Personal Data and receive a copy of the
              Personal Data that we hold.
            </li>
            <li>the right to rectification of your Personal Data;</li>
            <li>the right to erasure of your Personal Data.</li>
            <li>the right to restrict processing of your Personal Data.</li>
            <li>the right to object to processing of your Personal Data;</li>
            <li>the right to data portability.</li>
            <li>
              the right to lodge a complaint to a supervisory authority; and
            </li>
            <li>
              the right to withdraw consent to processing of Personal Data.
            </li>
          </ul>
          <p>
            To assert any of these rights, which applicable to you, please
            contact us at: <a href="mailto:privacy@nayax.com">privacy@nayax.com</a>.
            <br />
            For more information about your rights under the CCPA, please see
            below. We may request additional information from you when you
            contact us with a request concerning your data subjects' rights in
            order to: (i) verify your identity; (ii) determine the applicable
            laws; (iii) and locate your data. 
          </p>
        </li>
        <li>
          <strong>Will I receive SPAM from NAYAX CAPITAL ? </strong>
          <p>
            We may send you email or SMS communications, with information on new products, features, activities, services and periodic announcements or newsletters (“Marketing Materials”). If you are located in in the European Economic Area other than the UK or France, we will not send Marketing Materials to you unless you have approved the receipt of such materials, by subscribing to our newsletter and Marketing Materials. In case you have agreed to receive Marketing Materials and wish to rescind your consent, you may do so at any time by clicking “Unsubscribe” on the relevant communication or by contacting us at: <a href="mailto:privacy@nayax.com">privacy@nayax.com</a>.{" "}
          </p>
        </li>
        <li>
          <strong>
            Is Personal Information regarding children collected by us?{" "}
          </strong>
          <p>
            Our Service is a general audience Services which is not directed to
            persons under 18 years old or equivalent minimum age for providing
            consent to processing of Personal Information in the relevant
            jurisdiction (<b>“Child”</b>). We do not knowingly collect or solicit
            Personal Information from a Child. If we become aware that a Child
            has provided us with Personal Information, we will delete such data
            from our databases.{" "}
          </p>
        </li>
        <li>
          <strong>How does NAYAX CAPITAL protect your data? </strong>
          <p>
            We implement measures to reduce the risks of damage, loss of
            information and unauthorized access or use of information in
            accordance with the applicable law. However, these measures are
            unable to provide absolute information security. Therefore, although
            efforts are made to secure your personal information, it is not
            guaranteed and you cannot reasonably expect that the Service and its
            related databases will be immune from any wrongdoings, malfunctions,
            unauthorized interceptions or access, or other kinds of abuse and
            misuse.{" "}
          </p>
        </li>
        <li>
          <strong>Questions or concerns regarding privacy </strong>
          <p>
            If you have any questions or concerns regarding privacy issues,
            please send us a detailed message to: <a href="mailto:privacy@nayax.com">privacy@nayax.com</a> and we will
            make every effort to resolve your concerns without delay. NAYAX
            CAPITAL may, at any time and from time to time, modify this Privacy
            Policy. Modifications to this Privacy Policy will be posted on the
            website and shall be effective as of the date in which they are
            posted on the website.{" "}
          </p>
        </li>
        <li>
          <strong>
            PRIVACY NOTICE FOR CALIFORNIA RESIDENTS UNDER THE CALIFORNIA
            CONSUMER PRIVACY ACT
          </strong>
          <p>
            We have set out above the categories of Personal Information about
            California residents that we collect. As noted below, we do not sell
            your Personal Information or disclose it to third parties for a
            business purpose. We may disclose each of these categories of
            personal information to our service providers, who are not permitted
            to use your Personal Information except as necessary for performing
            Services on our behalf. We collect these categories of Personal
            Information from the sources and for the purposes described above.
            Our collection, use and disclosure of personal information about a
            California resident will vary depending upon the circumstances and
            nature of our interactions or relationship with such resident.
            Please note that the CCPA defines the term “sale” very broadly to
            include any exchange of data for consideration of any kind, not
            simply selling your data for monetary compensation.{" "}
          </p>
        </li>
        <li>
          <strong>CALIFORNIA CONSUMER RIGHTS</strong>
          <p>
            California law grants consumers certain rights and imposes
            restrictions on particular business practices as set forth below.
            California consumers have the right to request that we disclose what
            personal information we collect, use, disclose, and sell about you.{" "}
          </p>
          <ul>
            <li>
              <strong>
                Right to Opt-out of Sale of Personal Information (“Do Not Sell”)
              </strong>
              <p>
                California residents have the right to opt-out of our sale of
                their personal information. We do not sell your Personal
                Information to other businesses or third parties. However,
                because of how broadly “sale” is defined under the CCPA, the
                collection of data by our third-party digital advertising and
                web analytics service providers for our targeted advertising and
                analytics purposes may be considered a “sale” under the CCPA. To
                not have your information shared with such parties, you may
                manage your cookie preferences through our cookie widget web page.
              </p>
            </li>
            <li>
              <strong>Requests for Copy, Deletion and Right to Know</strong>
              <p>
                Subject to certain exceptions, California consumers have the
                right to make the following requests, at no charge, up to twice
                every 12 months. Please see below information on how to exercise
                your right. Deletion: the right to request deletion of personal
                information that we have collected about you, subject to certain
                exemptions. Copy: the right to request a copy of the specific
                pieces of personal information that we have collected about you
                in the prior 12 months. Right to Know (Collection): Where we
                have collected personal information about you, the right to
                request that we disclose certain information about how we have
                handled your personal information in the prior 12 months,
                including: the categories of personal information collected;
                categories of sources of personal information; business and/or
                commercial purposes for collecting and selling your personal
                information; and the categories of third parties/with whom we
                have disclosed or shared your personal information. Right to
                Know (Collection): Where we have collected Personal Information
                about you, the right to request that we disclose certain
                information about how we have handled your Personal Information
                in the prior 12 months, including: the categories of Personal
                Information collected; categories of sources of Personal
                Information; business and/or commercial purposes for collecting
                and selling your personal information (if applicable); and the
                categories of third parties/with whom we have disclosed or
                shared your personal information. Right to Know (Disclosure and
                Sale): Where we have sold or disclosed for a business purpose
                your Personal Information, the right to request that we disclose
                certain information about how we have handled your Personal
                Information in the prior 12 months, including: the categories of
                Personal Information collected; categories of third parties to
                whom your Personal Information has been sold and the specific
                categories of personal information sold to each category of
                third party (if applicable); categories of third parties to whom
                Personal Information has been disclosed; and the categories of
                Personal Information that we have disclosed or shared with a
                third party for a business purpose. Submitting Requests: You can
                exercise your rights by emailing us at: <a href="mailto:privacy@nayax.com">privacy@nayax.com</a>. Once
                you submit your request, we will take steps to attempt to verify
                your identity. We will seek to match the information in your
                request to the Personal Information we maintain about you. As
                part of our verification process, we may ask you to submit
                additional information, use identity verification services to
                assist us, or if you have created an account on our Services, we
                may ask you to sign into your account as part of our identity
                verification process. Please understand that, depending on the
                type of request you submit, to protect the privacy and security
                of your personal information, we will only complete your request
                where we are satisfied that we have verified your identity to an
                appropriate degree of certainty. We will make every reasonable
                effort to respond to you within 45 days after we receive a
                verified request. If we are unable to meet this timescale, we
                will contact you to let you know why it will take more than 45
                days and respond as soon as possible over the next 45-day
                period.{" "}
              </p>
            </li>
          </ul>
        </li>
        <li>
          <strong>INCENTIVES AND DISCRIMINATION </strong>
          <p>
            The CCPA prohibits discrimination against California consumers for
            exercising their rights under the CCPA and imposes requirements on
            any financial incentives offered to California consumers related to
            their personal information. We do not currently offer financial
            incentives for the collection of personal information. If consumers
            exercise their rights under CCPA, businesses may not discriminate
            against them including by denying or providing a different level or
            quality of goods or services or charging or suggesting that a
            business will charge different prices or rates or impose penalties,
            unless doing so is reasonably related to the value provided to the
            consumer by the consumer’s data.{" "}
          </p>
        </li>
        <li>
          <strong>NEVADA RESIDENTS </strong>
          <p>
            We do not sell your personal information as defined under Nevada
            law. However, if you are a Nevada resident, you may submit a request
            that we not sell any personal information we have collected about
            you by contacting us at <a href="mailto:privacy@nayax.com">privacy@nayax.com</a>.{" "}
          </p>
      <strong>CONTACT US</strong>
      <p>
        If you have any questions about this Privacy Policy, you may contact us
        as follows: By sending our privacy team email at: <a href="mailto:privacy@nayax.com">privacy@nayax.com</a>. By
        regular mail at: NAYAX Capital (IOT Capital) Address: 3 Arik Einstein,
        Herzliya, Israel.{" "}
      </p>
        </li>
      </ol>
    </div>
  );
};
